/*
  vg-cart-extras.js - the Add buttons rendered by snippets/vg-cart-extras.liquid.

  Adds the extra with the same `For` / `_vg_host` stamps the product-page add-ons
  use, so vg-cart-guard.js treats it exactly like one ticked on the product page.

  On the cart page the whole cart is reloaded so totals, lines and the extras
  block all agree. In the "Added to cart" popup the button just turns into
  "Added" and the header cart count is refreshed, so the shopper is not
  bounced off the page they were browsing.

  Loaded site-wide from snippets/meta-tags.liquid, next to vg-cart-guard.js.
*/
(function () {
  function addUrl() {
    return (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';
  }

  function refreshBubble() {
    return fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target || !json['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(json['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) target.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  function refreshCartSection() {
    var wrap = document.querySelector('[data-vg-cx-section]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-vg-cx-section');
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vg-cx-section]');
        if (fresh) wrap.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-vg-cx-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding';
    var inPopup = !!btn.closest('#cart-notification');

    fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{
        id: Number(btn.getAttribute('data-variant')),
        quantity: 1,
        properties: { 'For': btn.getAttribute('data-for'), '_vg_host': btn.getAttribute('data-host') }
      }] })
    })
      .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
      .then(function () {
        if (inPopup) {
          btn.textContent = 'Added';
          btn.classList.add('is-done');
          refreshBubble();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  });

  // Cart page: quantity changes and removals re-render Dawn's own sections, not ours.
  // PUB_SUB_EVENTS is a top-level const in constants.js, so it is not on window.
  function hookCartUpdates() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartSection);
    }
  }
  if (document.readyState !== 'loading') { hookCartUpdates(); }
  else { document.addEventListener('DOMContentLoaded', hookCartUpdates); }
})();
